import React from "react";
import {
  FunctionField,
  ReferenceField,
  ShowProps,
  TextField,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import TypeField from "../../components/TypeField";
import CustomLabeled from "../../components/layout/CustomLabeled";

const Summary = (_props: ShowProps) => {
  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Student
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <CustomLabeled name="Id">
            <TextField source="studentId" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <CustomLabeled name="Name">
            <ReferenceField source="studentId" reference="students">
              <FunctionField
                render={(record: any) =>
                  `${record.firstName} ${record.lastName}`
                }
              />
            </ReferenceField>
          </CustomLabeled>
        </Grid>
        <Grid item xs={4}>
          <CustomLabeled name="CreatedAt">
            <ReferenceField
              source="studentId"
              reference="students"
              link={false}
            >
              <CustomDateField source="createdAt" emptyText="-" isDateTime />
            </ReferenceField>
          </CustomLabeled>
        </Grid>
        <Grid item xs={4}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Change Request Detail
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Wef Date">
            <CustomDateField source="wefDate" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="End Date">
            <CustomDateField source="endDate" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={2}>
          <CustomLabeled name="Type">
            <TypeField source="type" type="changeRequest_FormType" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={2}>
          <CustomLabeled name="Routeplanner Role">
            <TypeField
              source="busScheduleStatus"
              label="Routeplanner Role"
              type="changeRequest_busSchedule"
            />
          </CustomLabeled>
        </Grid>
        <Grid item xs={2}>
          <CustomLabeled name="Cs Role">
            <TypeField
              source="invoiceStatus"
              label="CS Role"
              type="changeRequest_invoice"
            />
          </CustomLabeled>
        </Grid>
        <Grid item xs={2}>
          <CustomLabeled name="Status">
            <TypeField source="status" type="changeRequest_status" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={4}></Grid>

        <Grid item xs={4}>
          <CustomLabeled name="Description">
            <TextField source="description" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <CustomLabeled name="Cs Description">
            <TextField source="csDescription" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={8}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
